import axiosInstance from "../config/axiosInstance";
import API from "../config/config";
import { toast } from "react-toastify";

const DRIVERS_METRICS_TIMEOUT_MS = 120000;

class DriversMetricsService {
  static async getDriversMetrics(params = {}) {
    try {
      const queryString = new URLSearchParams(params).toString();
      const url = queryString
        ? `${API.ADMIN.DRIVERS_METRICS}?${queryString}`
        : API.ADMIN.DRIVERS_METRICS;

      const response = await axiosInstance.get(url, {
        timeout: DRIVERS_METRICS_TIMEOUT_MS,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching drivers metrics:", error);
      toast.error(
        error?.response?.status === 504
          ? "Drivers metrics timed out. Please try again or narrow the date range."
          : "Failed to fetch drivers metrics"
      );
      throw error;
    }
  }
}

export default DriversMetricsService;
